// extracted by mini-css-extract-plugin
module.exports = {"card":"CategoriesBtn_card__YqdFt","active":"CategoriesBtn_active__1J0BU","icon":"CategoriesBtn_icon__PMl-X","arrowIcon":"CategoriesBtn_arrowIcon__38fKZ"};